import {CrossIcon, IconButton, Modal} from '@yandex-delivery/blocks'
import React, {useCallback, useEffect, useState} from 'react'

import Postcard from '../postcard/Postcard'
import type {Props} from '../types'
import PostcardBanner from './PostcardBanner'
import {classes, panelClasses, postcardClasses} from './PostcardMobile.classes'

type State = {
  showBanner: boolean
  showPanel: boolean
}

const PostcardMobile: React.FC<Props> = ({data}) => {
  const [state, setVisibility] = useState<State>({
    showBanner: false,
    showPanel: false,
  })
  const closeHandler = useCallback(() => setVisibility({showBanner: true, showPanel: false}), [])
  const showHandler = useCallback(() => setVisibility({showBanner: false, showPanel: true}), [])

  useEffect(() => {
    const timerID = setTimeout(showHandler, 1000)

    return () => clearTimeout(timerID)
  }, [showHandler])

  return (
    <>
      <Modal.SidePanel anchor="bottom" className={panelClasses.paper} opened={state.showPanel}>
        <IconButton className={classes.closeButton} data-theme-invert onPress={closeHandler}>
          <CrossIcon />
        </IconButton>
        <Postcard classes={postcardClasses} data={data} />
      </Modal.SidePanel>
      {state.showBanner && <PostcardBanner imageSrc={data.content.url} />}
    </>
  )
}

export default PostcardMobile
